<template>
  <div>
    <data-table-card
      :items="items"
      v-on:updateData="getAdjustments"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'pallets-adjustments-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:cards="slotProps">

          <div class="row no-gutters" @click="print(slotProps.item.id,slotProps.item.pallet_adjustment_number)">

            <div class="col-12 p-3">

               <h6 class="font-weight-bold mb-0">
                <small class="text-black-50 font-weight-normal float-right ">{{
                  slotProps.item.pallet_adjustment_number
                }}</small>
                {{ slotProps.item.branch.name }}
              </h6>


              {{
                moment(new Date(slotProps.item.created_at)).format(
                  "DD MMM YY, HH:mm"
                )
              }} | {{ slotProps.item.user.name }}


               <br>
              <small class="text-black-50 "> {{ slotProps.item.remark }} </small>
               <br><br>


              <span
                class="text-info "
                v-if="slotProps.item.credit != null"
                >Add: <strong> {{ slotProps.item.credit}} </strong></span
              >

              <span
                class="text-warning"
                v-if="slotProps.item.debit != null && slotProps.item.is_damaged == 0"
                >Subtract: <strong> {{ slotProps.item.debit }}</strong></span
              >

              <span
                class="text-danger "
                v-if="slotProps.item.debit != null && slotProps.item.is_damaged == 1"
                >Damaged: <strong> {{ slotProps.item.debit }}</strong></span
              >

                 <span
                class="badge badge-primary float-right"

                v-if="slotProps.item.branch"
                >{{ slotProps.item.branch.code }}</span
              >


            </div>
          </div>


      </template>
    </data-table-card>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'pallets-adjustments' })"
      :lazy="true"
    >
      <router-view
        @palletAdjustmentCreated="palletAdjustmentCreated()"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import palletRepo from "@/api/repos/palletRepo";
import dataTableCard from "@/components/common/DataTableCard";

export default {
  components: {
    dataTableCard: dataTableCard,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort:  { column: "created_at", label: "Date Created Desc", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },

      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getAdjustments({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async getFilterData() {
      let { data } = await palletRepo.branches();

      this.filterOptions.push({
        column: "group-heading",
        label: "from branch",
      });

      data.branches.forEach((p) => {
        this.filterOptions.push({
          column: "branch_id",
          value: p.id,
          label: p.name,
        });
      });


    },

    async getAdjustments(e) {
      this.isLoad = true;
      try {
        let { data } = await palletRepo.adjustments(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.adjustments.data;
        this.totalRows = data.adjustments.total;
        this.page = data.adjustments.current_page;
        this.fromRow = data.adjustments.from;
        this.toRow = data.adjustments.to;
        this.lastPage = data.adjustments.last_page;

        this.filterOptions = [];

        this.getFilterData();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    async print(id,number) {

      this.isLoad = true

      try {
        let response = await palletRepo.adjustmentPrint(
          id
        );
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `pallet_adjustment_${number}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      }finally{
        this.isLoad = false
      }
    },

    palletAdjustmentCreated() {
      this.$bvToast.toast("Adjustment Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getAdjustments({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });


    },


  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
